import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import AITrainerMain from "@/features/aiTrainer/components/AITrainerMain";
import SalesCoachMain from "@/features/salesCoach/components/SalesCoachMain";
import CommonSegmentedTabs from "@/shared/components/ui/Tabs/SegmentedTabs";
import { BrainCircuit, GraduationCap, Sparkles } from "lucide-react";

const AiWorkspace = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(
    tabParam === "sales-coach" ? "sales-coach" : "ai-trainer"
  );

  useEffect(() => {
    if (tabParam === "sales-coach" || tabParam === "ai-trainer") {
      setActiveTab(tabParam);
    }
  }, [tabParam]);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    setSearchParams({ tab: newTab });
  };

  const workspaceTabs = [
    {
      key: "ai-trainer",
      title: "AI Trainer",
      icon: <BrainCircuit className="w-3.5 h-3.5" />,
    },
    {
      key: "sales-coach",
      title: "Sales Coach",
      icon: <GraduationCap className="w-3.5 h-3.5" />,
    },
  ];

  return (
    <div className="px-4">
      <div className="flex flex-col h-[calc(100vh-30px)] w-full bg-white dark:bg-gray-900 border border-gray-200/80 dark:border-gray-800 rounded-2xl shadow-sm overflow-hidden">
        {/* Top Header Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-gray-100 dark:border-gray-800 px-6 py-4 bg-gray-50/50 dark:bg-gray-900">
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-[rgb(32_124_151)]/10 text-[rgb(32_124_151)] dark:text-secondary-light">
              <Sparkles size={18} />
            </div>
            <div>
              <h1 className="text-base font-bold text-gray-900 dark:text-gray-100 flex items-center gap-2">
                AI Workspace
                <span className="text-[10px] font-bold text-white bg-gradient-to-r from-[rgb(32_124_151)] to-[#058BB3] px-2.5 py-0.5 rounded-full uppercase tracking-wider">
                  Copilot
                </span>
              </h1>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                Refine your outreach strategies with interactive training and
                simulations.
              </p>
            </div>
          </div>

          {/* Reusable Segmented Tabs Component */}
          <div className="self-start sm:self-auto">
            <CommonSegmentedTabs
              selectedKey={activeTab}
              onSelectionChange={handleTabChange}
              tabs={workspaceTabs}
            />
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 min-h-0 w-full bg-[#fbfbfa] dark:bg-gray-950 [&>div]:!h-full p-6">
          {activeTab === "ai-trainer" ? (
            <div
              key="ai-trainer"
              className="animate-fade-in-up h-full [&>div]:!h-full"
            >
              <AITrainerMain />
            </div>
          ) : (
            <div
              key="sales-coach"
              className="animate-fade-in-up h-full [&>div]:!h-full"
            >
              <SalesCoachMain />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiWorkspace;
